<template>
  <validation-observer ref="simpleRules">
    <b-form class="mt-1">
      <b-row>
        <!-- User Select -->
        <b-col>
          <b-form-group
            :label="$t('Assign To')"
            label-for="mc-assigned-to"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Assign To')"
              rules="required"
            >
              <v-select
                id="vue-select-assigned-to"
                v-model="item.assignedTo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionUserFormatted"
                :reduce="user => user.email"
                label="fullName"
                :placeholder="$t('Select...')"
                :clearable="false"
                :state="errors.length > 0 ? false:null"
                :selectable="selectable"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>
      </b-row>

      <b-row>
        <!-- Action Plan -->
        <b-col>
          <b-form-group
            :label="$t('Action Planned')"
            label-for="mc-action-planned"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Action Planned')"
              rules="required"
            >
              <v-select
                id="vue-select-action-planned"
                v-model="item.actionPlanned"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionActionPlan||[]"
                :placeholder="$t('Select...')"
                :clearable="false"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- Action Planned Date -->
        <b-col>
          <b-form-group
            :label="$t('Action Planned Date & Time')"
            label-for="mc-action-planned-date"
          >
            <flat-pickr
              v-model="item.actionPlannedDate"
              class="form-control"
              :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
            />
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          <!-- Description -->
          <b-form-group
            :label="$t('Action Description')"
            label-for="mc-description"
          >
            <b-form-textarea
              v-model="item.assignDescription"
              :placeholder="$t('Description...')"
            />

          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        variant="primary"
        :disabled="inProgress"
        @click="validationForm"
      >
        <span v-if="!inProgress">{{ $t('Assign') }}</span>
        <span v-else>{{ $t('Please wait...') }}</span>
      </b-button>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BRow, BCol, BFormTextarea, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    projectid: {
      type: [Number, String],
      required: true,
    },
    orjref: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
      defaultItem: {
        assignedTo: null,
        assignedDate: null,
        assignedBy: null,
        actionPlanned: null,
        actionTaken: null,
        actionTakenDate: null,
      },
      required,
      optionUserSuggested: [],
      optionUserAll: [],
      optionActionPlan: [],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
    optionUserFormatted() {
      let finalList = []
      if (this.optionUserSuggested.length) {
        finalList = [...[{ fullName: this.$t('SUGGESTED PERSON LIST') }], ...this.optionUserSuggested.map(u => ({ email: u.email, fullName: `${u.fullName} (${u.email})` }))]
      }

      if (this.optionUserAll.length) {
        finalList = [...finalList, ...[{ fullName: this.$t('ALL USERS LIST') }], ...this.optionUserAll.map(u => ({ email: u.email, fullName: `${u.fullName} (${u.email})` }))]
      }

      return finalList
    },
  },
  async created() {
    await this.getUserOptions()
    await this.getActionPlanOptions()
  },
  methods: {
    selectable(item) {
      if (!item.email) return false
      return true
    },
    async getUserOptions() {
      await useJwt.axiosIns.get(`hotalert/assigments/personlist/${this.projectid}/${this.orjref}`).then(async response => {
        this.optionUserSuggested = response.data
        await useJwt.axiosIns.get('user/short').then(response2 => {
          this.optionUserAll = response2.data.filter(e => !this.optionUserSuggested.map(f => f.email).includes(e.email))
        })
      })
    },
    async getActionPlanOptions() {
      await useJwt.axiosIns.get(`hotalert/${this.projectid}/ActionPlanOptions`).then(response => {
        if (response.data) {
          this.optionActionPlan = response.data
        }
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.inProgress = true
          const postItem = JSON.parse(JSON.stringify(this.item))
          useJwt.axiosIns.post('hotAlert/assigments', postItem)
            .then(response => {
              if (response.data) {
                this.inProgress = false
                this.$emit('submit', postItem.id)
              }
            })
            .catch(e => {
              this.inProgress = false
              console.log(e)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
